import React from 'react'

import SearchComponent from '../components/features/SearchComponent'

const Search = () => {
  return (
    <div>
      <section className="bg-image pt-25 pb-25">
            <div className="container">
                <h2 className="Banner-Title">Trees</h2>
               
            </div>
        </section>
        <SearchComponent/>
    </div>
  )
}

export default Search